import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AnimatedSection, fadeUp } from "@/components/motion";

const brands = [
  { name: "Krish Fashion", logo: "/krish-fashion-logo.png", division: "Unstitched Dress Materials", markets: "Pan-India · Strongholds in Delhi NCR & South India" },
  { name: "IOLY", logo: "/ioly-logo.png", division: "Readymade Garments", markets: "Gujarat · Rajasthan · Punjab · Bangalore · Kerala" },
  { name: "KF Prints", logo: "/kf-logo.png", division: "Fabrics Division", markets: "Surat · Mumbai · Dubai · Saudi Arabia" },
];

const highlights = [
  "Pan-India distribution network",
  "Strongholds in Delhi NCR & South India",
  "Export corridor: Surat → Mumbai → The Gulf",
  "Long-standing international partnerships",
];

export const GlobalReadinessSection = () => (
  <AnimatedSection id="global" className="py-24 lg:py-32 bg-background">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div variants={fadeUp}>
          <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-4">Our Presence</p>
          <h2 className="text-4xl md:text-5xl font-serif tracking-tight text-foreground mb-6">
            Pan-India Strength.<br />Global Vision.
          </h2>
          <p className="text-base font-sans text-muted-foreground leading-relaxed mb-8">
            Three brands carry our legacy from Surat to wardrobes across India — and to long-standing partners in Dubai and Saudi Arabia.
          </p>
          <ul className="space-y-4 mb-10">
            {highlights.map((item) => (
              <li key={item} className="flex items-center gap-3">
                <CheckCircle size={16} className="text-[#C5A059] flex-shrink-0" />
                <span className="text-sm font-sans text-foreground">{item}</span>
              </li>
            ))}
          </ul>
          <Link to="/global-presence">
            <Button
              data-testid="explore-presence-btn"
              variant="outline"
              className="rounded-none px-8 py-5 text-xs uppercase tracking-[0.15em] font-sans border-foreground text-foreground hover:bg-foreground hover:text-white"
            >
              Explore Our Presence <ArrowRight size={14} className="ml-2" />
            </Button>
          </Link>
        </motion.div>
        <motion.div variants={fadeUp} className="space-y-4" data-testid="brand-presence-cards">
          {brands.map((b) => (
            <Link
              key={b.name}
              to="/global-presence"
              data-testid={`brand-card-${b.name.toLowerCase().replace(/\s/g, "-")}`}
              className="group flex items-center gap-6 bg-white border border-border p-6 hover:border-[#C5A059] transition-colors duration-300"
            >
              <div className="w-28 h-16 flex items-center justify-center flex-shrink-0">
                <img src={b.logo} alt={`${b.name} logo`} className="max-w-full max-h-full object-contain" />
              </div>
              <div className="border-l border-border pl-6">
                <p className="font-serif text-lg text-foreground group-hover:text-[#C5A059] transition-colors duration-200">{b.name}</p>
                <p className="text-xs font-sans uppercase tracking-[0.15em] text-[#C5A059] mt-1">{b.division}</p>
                <p className="text-sm font-sans text-muted-foreground mt-2">{b.markets}</p>
              </div>
            </Link>
          ))}
        </motion.div>
      </div>
    </div>
  </AnimatedSection>
);
